// assets/archive-gate.js
document.addEventListener('DOMContentLoaded', function () {
  const root = document.getElementById('archive-gate-root');
  if (!root) return;

  const collectionHandle = root.dataset.collectionHandle;
  const klaviyoPublicKey = root.dataset.klaviyoPublicKey;
  const klaviyoListId = root.dataset.klaviyoListId;
  const emailInput = document.getElementById('archive-gate-email');
  const emailSubmit = document.getElementById('archive-gate-email-submit');
  const banner = document.getElementById('archive-gate-banner');

  function showBanner(message, type) {
    const inner = document.createElement('div');
    inner.className = 'banner__content';
    inner.textContent = message;

    const outer = document.createElement('div');
    outer.className = 'banner banner--' + (type || 'error');
    outer.appendChild(inner);

    banner.textContent = '';
    banner.appendChild(outer);
    banner.hidden = false;
  }

  function setLoading(btn, loading) {
    btn.disabled = loading;
    btn.setAttribute('aria-busy', String(loading));
  }

  async function subscribe(email) {
    setLoading(emailSubmit, true);
    banner.hidden = true;
    banner.textContent = '';

    const profile = { type: 'profile', attributes: { email: email } };
    const body = {
      data: {
        type: 'subscription',
        attributes: {
          profile: { data: profile },
        },
      },
    };

    if (klaviyoListId) {
      body.data.relationships = { list: { data: { type: 'list', id: klaviyoListId } } };
    }

    try {
      const res = await fetch(
        'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(klaviyoPublicKey),
        {
          method: 'POST',
          headers: {
            'content-type': 'application/json',
            revision: '2024-10-15',
          },
          body: JSON.stringify(body),
        }
      );

      // Klaviyo returns 202 on success
      if (res.ok) {
        window.location.href = '/collections/' + collectionHandle;
      } else {
        const errText = await res.text().catch(() => '');
        console.error('Klaviyo subscription failed', res.status, errText);
        setLoading(emailSubmit, false);
        showBanner('Something went wrong. Please try again.');
      }
    } catch (_) {
      // Network failure — still redirect so the user isn't blocked
      window.location.href = '/collections/' + collectionHandle;
    }
  }

  emailSubmit.addEventListener('click', function (e) {
    e.preventDefault();
    var email = emailInput.value.trim();
    if (!email || !emailInput.validity.valid) {
      showBanner('Please enter a valid email address.');
      return;
    }
    subscribe(email);
  });

  emailInput.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') emailSubmit.click();
  });
});
